import {Reserve} from "../common/types/Types";
import {useHistory} from "react-router-dom";

interface ReserveBadgeProps {
    reserve: Reserve;
    withLink?: boolean;
    withPosition?: boolean;
    xRatio?: number;
    yRatio?: number;
}

const ReserveBadge = (props: ReserveBadgeProps) => {
    const {reserve, withLink = false, withPosition = false, xRatio = 1, yRatio = 1} = props;
    const history = useHistory();

    let backgroundColor;
    if (reserve.indicRas) {
        backgroundColor = '#198754';
    } else if (reserve.statutRefStatut === 1) {
        backgroundColor = '#dc3545';
    } else {
        backgroundColor = '#003849';
    }

    const badgeLength = `${reserve.numBadge}`.length;
    let fontSizeStyle = {};

    if (badgeLength === 3) {
        fontSizeStyle = {
            position: 'relative',
            left: '-5px'
        }
    } else if (badgeLength === 4) {
        fontSizeStyle = {
            position: 'relative',
            left: '-5px',
            fontSize: '0.8rem'
        }
    }

    return <div className={`badge badge-danger badge-reserve ${withLink ? 'cursor-pointer' : ''}`}
                key={reserve.refReserve}
                style={withPosition ? {
                    position: 'absolute',
                    left: reserve.coordonneeX && xRatio ? (reserve.coordonneeX - 24) * xRatio : 0,
                    top: reserve.coordonneeX && yRatio ? reserve.coordonneeY * yRatio : 0,
                    backgroundColor
                } : {backgroundColor}}
                onClick={() => {
                    if (withLink) {
                        history.push(`/reserve/${reserve.refReserve}`);
                    }
                }}
    ><span style={fontSizeStyle}>{reserve.numBadge}</span></div>;
};

export default ReserveBadge;
